var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.formRef,domProps:{"innerHTML":_vm._s(_vm.paymentData)}})
}
var staticRenderFns = []

export { render, staticRenderFns }